import React from 'react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/miKeNXnKoUZ4pNJ3m9H5UE/PNG-website-file-dark-Transparent-background.png';
export function Footer() {
  return <footer className="w-full bg-navy border-t border-navy-border px-4 py-12" data-id="element-9">
      <div className="max-w-4xl mx-auto text-center" data-id="element-10">
        <img src={LOGO_URL} alt="Start Launching Creatives" className="w-36 md:w-44 mx-auto mb-4" data-id="element-11" />
        <p className="text-red font-oswald text-xs tracking-widest uppercase mb-6" data-id="element-12">
          Conecta. Vende. Lanza.
          <br data-id="element-13" />
          Sin aparecer en cámara y sin complicaciones.
        </p>
        <p className="text-gray/50 font-inter text-xs" data-id="element-14">
          &copy; 2026 Start Launching Creatives. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}